<template>
  <div class="progress-indication-2">
    <cashflow-loader />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import CashflowLoader from '@/pages/responsive-pages/authenticated/onboard2/steps/cashflow-loader/CashflowLoader';
import Segment from '../../../../../Segment';

export default {
  async created() {
    Segment.trackUserGot('ProgressStep3Entered');
    Segment.trackUserGotToPixel('OD');
    await this.init();
    this.setLoadingState(true);
  },
  components: {
    CashflowLoader,
  },
  name: 'ProgressIndication2',
  computed: {
    description() {
      return 'מצוין, על בסיס ההגדרות שלך המערכת תחשב לך עכשיו את התזרים החודשי הראשון!';
    },
  },
  methods: {
    ...mapActions('tour', ['init']),
    ...mapMutations('onboardingState', ['setLoadingState']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .progress-indication-2 {
    height: 100%;

    .progress-indication {
      @include white-page-frame;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .content {
        .description {
          width: 100%;
          @include responsive-padding;
          padding-top: 40px;
          padding-bottom: 40px;
          background-color: #2dc05c;
          color: $riseup_white;
          font-size: 22px;
          line-height: 1.27;
          font-family: SimplerPro;
          font-weight: bold;
        }
      }

      .button-wrapper {
        width: 100%;
        @include responsive-padding;
        @include responsive-padding-top-bottom;

        .button {
          width: 100%;
        }
      }
    }
  }
</style>
